import React from "react";
import AddToCartPage from "../Components/Cart/AddToCartPage";

import Navbar from "../Components/Navbar";

const Cart = () => {
  return (
    <div>
      <Navbar />
      <AddToCartPage />
    </div>
  );
};

export default Cart;
